export const creditShared = {
    layout: {
        productInfo: {
            showBalanceAndPositiveOutstandingAmount: true,
        },
    },
    menu: {
        supplementary: {
            enabled: true,
        },
    },
    reservations: {
        description: true,
        status: true,
    },
    supplementary: {
        enabled: true,
    },
    functions: {
        tpLimits: {
            enabled: true,
            types: ['CREDIT'],
            editor: {
                limitTypes: ['ATM', 'POS', 'INTERNET', 'TOTAL'],
                showMaxLimitHelp: true,
            },
        },
        payUp: {
            validAccounts: {
                domesticOrOwnTransferAllowed: true,
                currentAndSavingsAccounts: true,
            },
        },
    },
    settings: {
        displayIBAN: true,
    },
    showAuthorizedAsSubCard: true,
};
